import React from 'react';
import cn from 'classnames';
import SlickSlider from '@/Framework/UI/Molecules/SlickSlider';
import Panel from '../../Panel';
import Office from './Office';
import { OFFICE_LIST, officesSliderSettings } from '../constants';

import { clearfixStyles } from '@dealroadshow/uikit/core/components/Clearfix';
import contactUsStyles from '../contactUs.scss';
import officesStyles from './offices.scss';

const Offices = () => (
  <Panel
    classNameWrapper={ cn(contactUsStyles.topSpace, contactUsStyles.bottomSpace, clearfixStyles.clearfix) }
    classNameTitle={ officesStyles.title }
    title="Our Offices"
  >
    <div className={ officesStyles.officesContent }>
      <SlickSlider { ...officesSliderSettings }>
        {
          OFFICE_LIST.map(({
            photo,
            name,
            address,
          }) => (
            <Office
              key={ name }
              photo={ photo }
              name={ name }
              address={ address }
            />
          ))
        }
      </SlickSlider>
    </div>
  </Panel>
);

export default Offices;
